import { useQuery } from '@tanstack/react-query';
import CatalogService from '@utility/services/catalog';
import { catalogKeys } from '../lib/query-keys';

/* A V2 parent's variants, asked for only while its row is open. */
export function useCatalogV2Variations(parentId: string, enabled: boolean) {
  return useQuery({
    queryKey: catalogKeys.v2Variations(parentId),
    queryFn: async () => (await CatalogService.v2Variations(parentId)).data,
    enabled,
  });
}
